import { VStack, Box } from '@chakra-ui/react'
import NoteContainer from '../components/NoteContainer'
import ModuleContainer from '../components/ModuleContainer'
import CategoryContainer from '../components/CategoryContainer'
import TaskTitle from '../components/TaskTitle'
import TaskBreadcrumb from '../components/TaskBreadcrumb'
import TaskDescription from '../components/TaskDescription'
import GeneralContainer from '../components/GeneralContainer'
import ExclusiveContainer from '../components/ExclusiveContainer'

export default function N25_09_30() {
  return (
    <NoteContainer date={'30/09/2025'} version="20.6.0">
      <VStack w="full">
        <GeneralContainer>
          <VStack w="full">
            <CategoryContainer category="ADJUSTMENTS">
              <Box>
                <TaskTitle>Mais informações no cartão da questão do formulário</TaskTitle>
                <TaskBreadcrumb>Formulários/ questões</TaskBreadcrumb>
                <TaskDescription>
                  Agora aparece as tags da questão direto no cartão, sem a necessidade de abrir a janela de edição.
                </TaskDescription>
              </Box>
              <Box>
                <TaskTitle>Auxílio visual na edição da questão do formulário</TaskTitle>
                <TaskBreadcrumb>Formulários/ questões</TaskBreadcrumb>
                <TaskDescription>
                  Agora ao editar uma questão, aparece um alerta na cor amarela informando que existem campos não
                  salvos. A ideia é lembrar o usuário de clicar no botão para atualizar de fato as informações da
                  questão.
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </GeneralContainer>
        <ExclusiveContainer institutions={['teste', 'treinamento', 'agsus']} category="FEATURE">
          <ModuleContainer moduleName="APP_CITIZEN">
            <VStack w="full">
              <CategoryContainer category="FEATURE">
                <Box>
                  <TaskTitle important={true}>Holerite direto no App Cidadão</TaskTitle>
                  <TaskBreadcrumb>App Cidadão/ home</TaskBreadcrumb>
                  <TaskDescription>
                    Agora será possível gerar o holerite pessoal através do próprio perfil
                  </TaskDescription>
                </Box>
              </CategoryContainer>
            </VStack>
          </ModuleContainer>
        </ExclusiveContainer>

        <ModuleContainer moduleName="SERVICES_LETTER">
          <VStack w="full">
            <CategoryContainer category="ADJUSTMENTS">
              <Box>
                <TaskTitle>Alertas na edição do serviço</TaskTitle>
                <TaskBreadcrumb>Serviços/ Perfil do serviço</TaskBreadcrumb>
                <TaskDescription>
                  Ao editar um serviço, caso o serviço <strong>possa ser solicitado</strong> e ele{' '}
                  <strong>não seja regulado</strong>, aparecerá um alerta.
                </TaskDescription>
                <TaskDescription>
                  Ao editar um serviço, caso o serviço <strong>possa ser solicitado</strong> e ele{' '}
                  <strong>não tenha nenhuma configuração de quem possa solicitar</strong>, aparecerá um alerta.
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>
        <ModuleContainer moduleName="CITIZEN_PROFILE">
          <VStack w="full">
            <CategoryContainer category="FEATURE">
              <Box>
                <TaskTitle>Foto em tamanho maior no perfil unificado</TaskTitle>
                <TaskBreadcrumb>Cidadãos / perfil do cidadão</TaskBreadcrumb>
                <TaskDescription>
                  Agora será possível visualizar a foto em um tamanho maior ao clicar no avatar da pessoa unificada.
                </TaskDescription>
              </Box>
            </CategoryContainer>
            <CategoryContainer category="FIX">
              <Box>
                <TaskTitle>Correção do carregamento inicial do dashboard</TaskTitle>
                <TaskBreadcrumb>Qualidade de dados</TaskBreadcrumb>
                <TaskDescription>
                  Correção do carregamento inicial do dashboard que ficava carregando de forma inifinita até que algum
                  filtro fosse selecionado
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>
      </VStack>
    </NoteContainer>
  )
}
